import React, { useMemo, useCallback } from 'react';
import { Typography, ButtonMenu, ButtonsList, TextField, SwitchMode } from '@ann/web-components';
import {
  KnowledgeHeaderWrapper,
  HeaderRow,
  HeaderRowResponsive,
  TabsContainer,
  ViewModeContainer,
  SearchContainer,
  HeaderInfo,
} from '../KnowledgePage.styled';

const KnowledgeHeader = ({
  activeTab,
  onTabChange,
  viewMode,
  onViewModeChange,
  onBrowseDrives,
  onUploadClick,
  totalItems,
  fileInputRef,
  onFileSelect,
  isUploading,
  searchTerm,
  onSearchChange,
}) => {
  const handleMenuSelect = (value) => {
    if (value === 'browse-drives') {
      onBrowseDrives?.();
    } else if (value === 'upload') {
      onUploadClick?.();
    }
  };

  const handleTabChange = useCallback((tab) => {
    // Convertir el string a índice numérico
    const index = tab === 'drives' ? 0 : 1;
    onTabChange?.(index);
  }, [onTabChange]);

  // Memoized button items
  const buttonItems = useMemo(() => [
    {
      label: 'Shared Drives',
      onClick: () => handleTabChange('drives'),
      selected: activeTab === 0
    },
    {
      label: 'Uploaded Files',
      onClick: () => handleTabChange('documents'),
      selected: activeTab === 1
    },
  ], [activeTab, handleTabChange]);

  return (
    <KnowledgeHeaderWrapper>
      {/* Input de archivo oculto */}
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={onFileSelect}
        accept="*/*"
        multiple
      />

      <HeaderRow>
        <HeaderInfo>
          <Typography category="subtitle" size="medium" weight="bold" color="title">
            Data Access
          </Typography>
          <Typography category="body" size="medium" weight="regular" color="body">
            Choose what information your agent can use to answer questions.
          </Typography>
        </HeaderInfo>
        <ButtonMenu
          iconPosition="left"
          customIcon="plus"
          label={isUploading ? 'Uploading...' : 'Add'}
          menuPosition="bottom"
          onChange={handleMenuSelect}
          size="medium"
          type="secondary"
          width="260px"
        >
          <ButtonMenu.Menu>
            <ButtonMenu.Item label="Upload Knowledge" value="upload" />
            <ButtonMenu.Item label="Add from Drives" value="browse-drives" />
          </ButtonMenu.Menu>
        </ButtonMenu>
      </HeaderRow>

      <HeaderRowResponsive>
        <TabsContainer>
          <SearchContainer>
            <TextField
              iconLeft="search"
              onChange={onSearchChange}
              size="small"
              placeholder={activeTab === 0 ? "Search drives and documents..." : "Search documents..."}
              value={searchTerm || ''}
            />
          </SearchContainer>
          <ButtonsList
            items={buttonItems}
            size="medium"
          />
          <Typography category="body" size="small" color="body">
            {totalItems} sources
          </Typography>
        </TabsContainer>

        <ViewModeContainer>
          <SwitchMode
            mode={viewMode}
            onModeChange={onViewModeChange}
          />
        </ViewModeContainer>
      </HeaderRowResponsive>
    </KnowledgeHeaderWrapper>
  );
};

export default KnowledgeHeader;
